import React, { Fragment } from 'react'
import { Form, Button } from 'stylist'
import displayName from 'utils/displayName'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'

const { Group, Label, Field } = Form

const Text = ({ field, key }) => (
  <Group key={key}>
    <Label>{field.label || displayName(field.name)}:</Label>
    <Field
      name={field.name}
      render={({ renderError, setValue, valid, value }) => (
        <Fragment>
          <DatePicker
            customInput={
              <Button type="button">
                {value ? value.format('L') : 'Choose a Date'}
              </Button>
            }
            utcOffset={0}
            selected={typeof value !== 'string' ? value : null}
            onChange={setValue}
            minDate={moment()}
            maxDate={moment().add(2, 'years')}
            todayButton="Today"
            placeholderText="Select A Date"
          />
          {renderError()}
        </Fragment>
      )}
    />
  </Group>
)

export default Text



// WEBPACK FOOTER //
// ./src/components/fields/DateTime.js